import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const EVT = "workshop-draft-changed";
let cache = null;
let timer = null;

const emit = () => window.dispatchEvent(new Event(EVT));

export const fetchDraft = () => api.get("/business/workshop-draft")
  .then((r) => { cache = r.data || null; emit(); return cache; })
  .catch(() => null);

export const getDraft = () => cache;

export const saveDraft = (f, step) => {
  cache = { f, step, saved_at: new Date().toISOString() };
  emit();
  clearTimeout(timer);
  timer = setTimeout(() => api.put("/business/workshop-draft", { f, step }).catch(() => {}), 800);
};

export const flushDraft = (f, step) => {
  clearTimeout(timer);
  cache = { f, step, saved_at: new Date().toISOString() };
  emit();
  return api.put("/business/workshop-draft", { f, step });
};

export const clearDraft = () => {
  clearTimeout(timer);
  cache = null;
  emit();
  return api.delete("/business/workshop-draft").catch(() => {});
};

export function useWorkshopDraft(enabled) {
  const [draft, setDraft] = useState(cache);
  useEffect(() => {
    if (!enabled) return undefined;
    const on = () => setDraft(cache);
    window.addEventListener(EVT, on);
    fetchDraft();
    return () => window.removeEventListener(EVT, on);
  }, [enabled]);
  return draft;
}
